import { FeApi } from '../../..';
import {
  type JobPreview,
  JobPreviewSchema,
} from '../../../domain/entities/capacity-evaluation';

export function jobPreviewMapper(
  data: FeApi.ListJobsViewOutputSerializerJob,
): JobPreview {
  const result = JobPreviewSchema.safeParse({
    id: data.uuid,
    status: data.status,
    createdAt: data.created_at,
    chargeStartTime: data.charge_start_time,
    chargeEndTime: data.charge_end_time,
    dischargeStartTime: data.discharge_start_time,
    dischargeEndTime: data.discharge_end_time,
    sohc: data.sohc,
    dischargedEnergy: data.energy,
  });

  if (result.success) {
    return result.data;
  } else {
    console.error('Failed to parse JobPreview:', result.error);

    const validFields = Object.fromEntries(
      Object.entries(result.error.flatten().fieldErrors).map(([key, value]) => [
        key,
        value?.[0] ?? undefined,
      ]),
    );

    return JobPreviewSchema.parse({
      id: validFields.id ?? 'default-id',
      status: validFields.status ?? 'Pending',
      createdAt: validFields.createdAt ?? new Date(),
      chargeStartTime: validFields.chargeStartTime ?? new Date(),
      chargeEndTime: validFields.chargeEndTime ?? new Date(),
      dischargeStartTime: validFields.dischargeStartTime ?? new Date(),
      dischargeEndTime: validFields.dischargeEndTime ?? new Date(),
      dischargedEnergy: validFields.dischargedEnergy ?? 0,
      sohc: validFields.sohc ?? 0,
    });
  }
}
